import { ONE } from '../../constans/common-constants';

export const isElementScrollPositionBottom = (el: HTMLElement): boolean => {
  return Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) <= ONE;
};
